import React, { useMemo } from "react";
import { isMobile } from "react-device-detect";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./panorama.css"
import { useMetadata } from "hooks/query";
import { useSection } from "hooks/section";
import { useAddAffilicateRedirect } from "hooks/queries";

function usePanorama() {
    console.log("PANORAMA BEFORE METADATA");
    const metadataQuery = useMetadata();
    console.log("PANORAMA BEFORE USESECTION");
    let { sectionUrl } = useSection();
    console.log("PANORAMA SECTION", sectionUrl);

    if(!sectionUrl){
        sectionUrl ="eftergymnasial-utbildning"
    }
    return useMemo(() => {
        let matches =
            metadataQuery.isSuccess &&
            metadataQuery.data.banners.$values.filter(
                (value) =>
                   ( value.position === "Sectionwide" &&
                    value.identifier === (sectionUrl) || value.position ==="Sitewide") &&
                    value.size === "Panorama"
            );
        //let idx = Math.round(Math.random() * matches.length);
        return matches;
    }, [metadataQuery, sectionUrl]);
}

function Panorama() {

    console.log("PANORAMA BEFORE AFFILIATE REDIRECT");
    const mutation = useAddAffilicateRedirect();
    const banners = usePanorama();
    console.log("PANORAMA BANNER",banners);

    const settings = {
        dots: false,
        draggable: false,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 12000,
        slidesToShow: 1,
        slidesToScroll: 1,
        //vertical: true,
        pauseOnHover: true,
    };

    //let url = isMobile ? banner?.smallUrl : banner?.largeUrl;

   // if (url) {
           
        // const onClickHandler = async (homePage) => {
        //     try {
        //         await mutation.mutateAsync({ homePage: homePage });
        //     } catch (e) {
        //         console.log(e.message);
        //         return { [FORM_ERROR]: e.message };
        //     }
    
        //     window.open(homePage);
        // }

        return (

            <div className="text-center p-3 mb-5 margin-top" id="panoramaId">
                  <Slider {...settings}> 
                  {banners &&
                            banners.map((value) => {
                                return <a className="panoramadiv panorama_analytics" href={value.homePage}>{isMobile? (
                               <img className="img-fluid" src={value.smallUrl} loading="lazy" alt="panorama-banner"></img>
                            ) :
                            (
                                <img className="img-fluid" src={value.largeUrl} loading="lazy" alt="panorama-banner"></img>
                            )}</a>;
                            })}
                </Slider> 
               
            </div>
        );
    //}

   // return false;
}

export default Panorama;
